import { FC } from 'react';
import { C_Discount_Kind } from '../../../../../../../../../../../../graphql/generatedModel';
import {
  FieldsRow,
  FormNumericField,
  FormSelect,
  SelectMenuWithFooter,
} from '../../../../../../../../../../../../shared/components/form';
import { useTranslation } from 'react-i18next';
import {
  DictDiscountGroupsRes,
  DictQuantityDiscountsRes,
} from '../../../../../../../../../../../../shared/services/configsData/configsData.service';
import { Stack } from '@mui/material';

export const ConditionInputs: FC<IConditionInputs> = ({
  discountKindIdValue,
  discountGroups,
  quantityDiscounts,
}) => {
  const { t } = useTranslation();

  if (discountKindIdValue === C_Discount_Kind.DK2_ALL_ARTICLES) {
    return (
      <FieldsRow>
        <FormNumericField
          width='350px'
          name='discountOnGroup1'
          precision={2}
          label={t('customer.discountPercent')}
          noTrailingZeros
          max={999}
        />
      </FieldsRow>
    );
  }
  if (
    discountKindIdValue === C_Discount_Kind.DK3_ARTICLE_GROUPS ||
    discountKindIdValue === C_Discount_Kind.DK4_PRICE_REDUCE
  ) {
    return (
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          rowGap: 3,
          columnGap: 2,
          marginTop: 3,
        }}
      >
        {discountGroups
          ?.sort((a, b) => Number(a.id) - Number(b.id))
          ?.map((item) => (
            <FormNumericField
              key={item.id}
              name={`discountOnGroup${item.id}`}
              label={item.label + ', %'}
              noTrailingZeros
              precision={2}
              max={999}
              width='210px'
            />
          ))}
      </Stack>
    );
  }

  if (
    discountKindIdValue === C_Discount_Kind.DK5_QUANTITY_DISCOUNT ||
    discountKindIdValue === C_Discount_Kind.DK6_QUANTITY_DISCOUNT_GROUPS
  ) {
    return (
      <FieldsRow>
        <FormSelect
          label={t('customer.quantityDiscountValue')}
          width='350px'
          name='quantityDiscountSettingId'
          options={(quantityDiscounts as []) || []}
          disableClearable
          PaperComponent={(props) => (
            <SelectMenuWithFooter {...props} href='/settings/configuration/invoice' />
          )}
        />
      </FieldsRow>
    );
  }

  return <></>;
};

interface IConditionInputs {
  discountKindIdValue: C_Discount_Kind | undefined;
  discountGroups: DictDiscountGroupsRes;
  quantityDiscounts: DictQuantityDiscountsRes;
}
